import { render, staticRenderFns } from "./invoice-box.vue?vue&type=template&id=fa8642cc&scoped=true"
import script from "./invoice-box.vue?vue&type=script&lang=js"
export * from "./invoice-box.vue?vue&type=script&lang=js"
import style0 from "./invoice-box.vue?vue&type=style&index=0&id=fa8642cc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8642cc",
  null
  
)

export default component.exports